<template
  ><div>
    <b-row class="mb-4"
      ><b-col>
        <div class="tsny_header tsny_box-fill text-center subscore-breakdown">
          Subscore Breakdown
        </div>
      </b-col></b-row
    >
    <b-row>
      <b-col>
        <b-table
          class="tsny_text-mid text-center"
          borderless
          :items="formattedItems"
          :fields="fields"
          thead-tr-class="tsny_table-head"
          tbody-tr-class="tsny_table-body"
        >
          <template v-slot:cell(score)="data">
            <span :style="{ color: color }">{{ data.value }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { _ } from "vue-underscore";

export default {
  name: "SubscoreBreakdown",
  props: {
    subscoreBreakdown: {
      type: Object,
      default: null
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    formattedItems() {
      return _.keys(this.subscoreBreakdown)
        .map(key => ({
          subscoreArea: key,
          ...this.subscoreBreakdown[key]
        }))
        .filter(subscore => subscore.score);
    }
  },
  data() {
    return {
      fields: [
        { key: "subscoreArea" },
        { key: "correct" },
        { key: "incorrect" },
        { key: "omitted" },
        { key: "total" },
        { key: "score", label: "Score (1-15)" }
      ]
    };
  }
};
</script>

<style scoped>
.subscore-breakdown {
  padding: 5px 0;
}
</style>
